<template>
	<div class="theme-box pr overflow-hidden flex items-center">
		<span class="label-holder">
			<label for="theme-select" class="fw5">Theme:</label>
		</span>
		<span :class="[`fake-select`, $css(styles.fakeSelect)]">
			<select id="theme-select" v-on:change="onThemeChange">
				<option v-for="(theme) in themes" :value="theme.name"
						:selected="theme.name === selectedTheme" :key="theme.name">
					{{theme.name}}
				</option>
				<option v-if="selectedTheme === customTheme" value="custom" selected>
					Custom
				</option>
			</select>
		</span>
	</div>
</template>

<script>
	import { mapState, mapActions } from "vuex";
	import {getInMediaQuery as gimq, MQ_SIZES} from "@/utils/cssUtils";
	import consts from "@/common/consts";
	import {types} from "@/store/modules/widget";

	function styles() {
		return this.$style({
			fakeSelect: gimq(MQ_SIZES.M, {width: "178px"})
		});
	}

	export default {
		name: "ThemeSelector",
		data (){
			return{
				customTheme: consts.CUSTOM
			} ;
		},
		computed: {
			...mapState({
				themes: (state) => state.widget.themes,
				selectedTheme: (state) => state.widget.selectedTheme,
			}),
			styles
		},
		methods: {
			...mapActions("widget", [
				types.SELECT_THEME,
			]),
			onThemeChange(e){
				this[types.SELECT_THEME]({theme: e.target.value});
			}
		},
		watch:{}
	}
</script>

<style lang="scss" scoped>
	@import "../../../assets/scss/_variables.scss";

	.theme-box {
		border-bottom: 1px solid $heather;
		padding: 13px 0 14px;

		.label-holder {
			margin: 0 15px 0 0;
		}

		.fake-select {
			width: 184px;
		}
	}
</style>
